export const dropDownItemsProduct = [
  {
    label: 'Overview',
    url: 'https://www.google.com',
  },
  {
    label: 'Pricing',
    url: 'https://www.google.com',
  },
  {
    label: 'Marketplace',
    url: 'https://www.google.com',
  },
  {
    label: 'Features',
    url: 'https://www.google.com',
  },
  {
    label: 'Integrations',
    url: 'https://www.google.com',
  },
]

export const dropDownItemsCompany = [
  {
    label: 'About',
    url: 'https://www.google.com',
  },
  {
    label: 'Team',
    url: 'https://www.google.com',
  },
  {
    label: 'Blog',
    url: 'https://www.google.com',
  },
  {
    label: 'Careers',
    url: 'https://www.google.com',
  },
]

export const dropDownItemsContact = [
  {
    label: 'Contact',
    url: 'https://www.google.com',
  },
  {
    label: 'Newsletter',
    url: 'https://www.google.com',
  },
  {
    label: 'LinkedIn',
    url: 'https://www.google.com',
  },
]